import { centroid } from '@turf/turf';
import type { Feature, Geometry } from 'geojson';

import type { Infrastructure } from '@/features/map/types/map.types';

const NORMALIZE: Record<string, Infrastructure['type']> = {
  pump: 'pump',
  pumps: 'pump',
  culvert: 'culvert',
  canal: 'canal',
  dyke: 'dyke',
  dykes: 'dyke',
  lowlying: 'lowlying',
  landslide: 'landslide',
  landslides: 'landslide',
};

function geometryToPosition(geom: Geometry): [number, number] | null {
  if (geom.type === 'Point') {
    const c = geom.coordinates as number[];
    if (c.length >= 2 && Number.isFinite(c[0]) && Number.isFinite(c[1])) {
      return [c[0], c[1]];
    }
    return null;
  }
  try {
    const feat: Feature = { type: 'Feature', geometry: geom, properties: {} };
    const c = centroid(feat);
    const [lng, lat] = c.geometry.coordinates;
    if (Number.isFinite(lng) && Number.isFinite(lat)) return [lng, lat];
  } catch {
    /* ignore */
  }
  return null;
}

export function mapInfrastructureApiRow(raw: Record<string, unknown>): Infrastructure | null {
  const id = String(raw.id ?? '');
  if (!id) return null;
  const label = String(raw.label ?? '');
  const typeRaw = String(raw.type ?? raw.infrastructure_type ?? 'lowlying')
    .trim()
    .toLowerCase();
  const type = NORMALIZE[typeRaw] ?? 'lowlying';
  const geom = raw.geometry as Geometry | undefined;
  if (!geom) return null;
  const pos = geometryToPosition(geom);
  if (!pos) return null;
  const meta =
    raw.metadata && typeof raw.metadata === 'object'
      ? (raw.metadata as Infrastructure['details'])
      : {};
  return {
    id,
    name: label || id,
    type,
    position: pos,
    status: 'active',
    details: meta,
  };
}
